import NonEditableBlock from './base/non-editable-block';
import openingTag from './../../lib/computed-properties/ic-block-opening-tag';
import { hash } from '@intercom/pulse/lib/computed-properties';
import AttributeReplacer from '@intercom/embercom-composer/lib/attribute-replacer';
import Paragraph from '@intercom/embercom-composer/blocks/types/paragraph';
import { computed } from '@ember/object';
import { htmlEscape } from '@intercom/pulse/lib/computed-properties';
import { and, notEmpty } from '@ember/object/computed';
import Em from 'ember';
export default NonEditableBlock.extend({
  allowedEntities: ['attribute'],
  type: 'imageText',
  isMedia: true,
  isImageTextBlock: true,
  isPreviewMode: false,
  hasValidContent: and('hasText', 'hasImageUrl'),
  hasText: notEmpty('text'),
  hasImageUrl: notEmpty('imageUrl'),
  openingTag: openingTag('content', 'id'),
  closingTag: '</ic-block>',
  title: null,
  text: null,
  imageUrl: null,
  escapedImageUrl: htmlEscape('imageUrl'),
  innerHtml: Em.computed('title', 'text', 'escapedImageUrl', function () {
    if (!this.get('hasValidContent') && !this.get('isPreviewMode')) {
      return `${this.get('_zeroWidthSpace')}`;
    }
    let title = this.generateBlockFromText(this.get('title'));
    let text = this.generateBlockFromText(this.get('text'));
    let iconHtml = this.get('imageUrl') ? `<img class="block-image" src="${this.get('escapedImageUrl')}" />` : `<img class="block-image" />`;
    return this.outputHtml(iconHtml, title, text);
  }),
  placeholderInnerHtml: Em.computed('title', 'text', 'escapedImageUrl', function () {
    if (!this.get('hasValidContent') && !this.get('isPreviewMode')) {
      return `${this.get('_zeroWidthSpace')}`;
    }
    let title = this.get('title') ? this.generateBlockFromText(this.get('title')) : this.get('placeholderTitle');
    let text = this.get('text') ? this.generateBlockFromText(this.get('text')) : this.get('placeholderText');
    let iconHtml = this.get('imageUrl') || this.get('') ? `<img class="block-image" src="${this.get('escapedImageUrl')}" />` : `<img class="block-image" src="${this.get('placeholderImageUrl')}" />`;
    return this.outputHtml(iconHtml, title, text);
  }),
  placeholderImageUrl: 'https://downloads.intercomcdn.com/i/o/195704481/fde13be5b749bdb5975b8004/placeholder-image-centered.png',
  placeholderText: {
    innerHtml: '<span class="image-text-placeholder">Text paragraph. <br /> Image size is 80x80px</span>'
  },
  placeholderTitle: {
    innerHtml: '<span class="image-text-placeholder">Title</span>'
  },
  placeholderHtml: computed('openingTag', 'placeholderInnerHtml', 'closingTag', function () {
    return `${this.openingTag}${this.placeholderInnerHtml}${this.closingTag}`;
  }),
  outputHtml(iconHtml, title, text) {
    return `${this.get('_zeroWidthSpace')}` + `<div class="block-image-text" contenteditable="false">` + `<div class="block-image-container">` + `${iconHtml}` + `</div>` + `<div class="block-content composer-style-basic" style="padding-left: 16px">` + `<div class="block-image-text-title"><b>${title.innerHtml}</b></div>` + `<div class="block-image-text-text">${text.innerHtml}</div>` + `</div>` + `</div> ${this.get('_zeroWidthSpace')}`;
  },
  serialized: hash('type', 'title', 'text', 'imageUrl'),
  generateBlockFromText(text) {
    let block = Paragraph.create({
      text,
      config: this.get('config')
    });
    block.set('attributeReplacer', new AttributeReplacer(block));
    block.get('attributeReplacer').replaceAttributes();
    return block;
  }
});